import React from "react";
import { Modal, Button } from "react-bootstrap";
import styled from "styled-components";
//import './ModalCard.scss';

const Title = styled.h4`
font-size: 1em;
text-align: center;
color: #162b92;
font-weight: bolder;
margin-bottom: 0;
`
const TextField = styled.h5`
font-size: 1em;
text-align: center;
font-weight: bolder;
`
const DataField = styled.h5`
font-size: 1em;
text-align: center;
font-weight: bolde
`
const RowDetail = styled.span`
display: flex;
justify-content: space-between;
`

const ModalGenerarCodigoOtpShow = (props) => {

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      keyboard
      className="modalCard"
    >

      <Modal.Header >
        <Modal.Title id="contained-modal-title-vcenter">
          <Title>Transacciones Tarjetas</Title>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body scrollable="true" style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto', paddingInline: '12%' }}>
        
            <div>
              <RowDetail>
                <TextField>Fecha:</TextField><DataField ></DataField>
              </RowDetail>

              <RowDetail>
                <TextField>Hora:</TextField><DataField ></DataField>
              </RowDetail>

              

              <RowDetail>
                <TextField>Lugar:</TextField><DataField></DataField>
              </RowDetail>

              <RowDetail>
                <TextField>Monto:</TextField><DataField></DataField>
              </RowDetail>

              <RowDetail>
                <TextField>Saldo:</TextField><DataField></DataField>
              </RowDetail>
              <hr/>
            </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Aceptar</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalGenerarCodigoOtpShow;